import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/company'

function* fetchCompanysRefresh() {
  const fe = JSON.parse(localStorage.getItem('fetchCompanys'))
  if (fe == null) {
    fe.size = 10
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_COMPANY,
    result,
  })
}

function* fetchCompanys({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchCompanys'))
    if (fe != null) {
      size = fe.size || 10
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = 10
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchCompanys', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_COMPANY,
    result,
  })
}

function* fetchCompanyEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_COMPANY,
    result,
  })
}

function* fetchCompanySave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_COMPANY_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_COMPANYS,
  })
}

function* fetchCompanyDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_COMPANY_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_COMPANYS,
  })
}





function* setChooseCompany(payload) {
  yield put({
    type: actions.REQUESTING,

  }); 
  localStorage.setItem('company', JSON.stringify(payload));

  yield put({
    type: actions.SELECT_COMPANY,
    payload,
  });
}

function* loadCompany() {
  const payload = JSON.parse(localStorage.getItem('company'))
  if (payload !== null) {
    yield put({
      type: actions.SELECT_COMPANY,
      payload,
    }); 
  }
}


export default function* rootSaga() {
  yield all([
    loadCompany(),

    takeEvery(actions.CHOOSE_COMPANY, setChooseCompany),

    takeEvery(actions.FETCH_COMPANYS, fetchCompanys),
    takeEvery(actions.FETCH_COMPANY, fetchCompanyEdit),
    takeEvery(actions.SAVE_COMPANY, fetchCompanySave),
    takeEvery(actions.DELETE_COMPANY, fetchCompanyDelete),
    takeEvery(actions.RE_FETCH_COMPANYS, fetchCompanysRefresh),
  ])
}


